import { OWebApp, tViewDialog, OWebPageBase, OWebRouteContext, tPageRouteFull } from "oweb";
import UsersStore from "@/services/users";
import SectorsStore from './services/sectors';
import SurveysStore from './services/surveys';
import CompaniesStore from './services/companies';
import QuestionsStore from './services/questions';
import AnswersStore from './services/answers';
import UrlsStore from './services/urls';
import { VueConstructor } from 'vue';

const bundleCache = function <T, R>(fn: (ctx: R) => T): (ctx: R) => T {
	let map = (fn as any)[ '__cache_map' ] || new Map;

	(fn as any)[ '__cache_map' ] = map;

	return function (ctx: R) {
		if (!map.has(ctx)) {
			map.set(ctx, fn(ctx));
		}

		return map.get(ctx);
	}
};

const storeBundle = function (app: OWebApp) {
	console.log("[App] store bundle created for %s.", app.getAppName());
	let page: OWebPageBase<VueConstructor> = undefined as any,
		route: tPageRouteFull = undefined as any,
		routeContext: OWebRouteContext = undefined as any;

	return {
		ready: false,
		splash: true,
		frozen: false,
		page,
		route,
		routeContext,
		dialogs: [] as tViewDialog[],
		// for reactivity
		services: bundleCache(servicesBundle)(app)
	};
};

const servicesBundle = function (app: OWebApp) {
	console.log("[App] services bundle created for %s.", app.getAppName());

	return {
		users: new UsersStore(app),
		sectors: new SectorsStore(app),
		surveys: new SurveysStore(app),
		answers: new AnswersStore(app),
		companies: new CompaniesStore(app),
		questions: new QuestionsStore(app),
		urls: new UrlsStore(app)
	};
};

export default { store: bundleCache(storeBundle), services: bundleCache(servicesBundle) };
